import * as React from 'react';
import { createUseStyles } from 'react-jss';

interface IconButtonProps {
    onClick: () => void;
    title: string;
    disabled?: boolean;
    className?: string;
    children: React.ReactElement | React.ReactElement[];
}

const useStyles = createUseStyles({
    button: {
        cursor: 'pointer'
    }
});

const IconButton: React.FC<IconButtonProps> = ({
    onClick,
    title,
    className,
    disabled = false,
    children
}: IconButtonProps) => {
    const classes = useStyles();

    return (
        <button
            className={classes.button + (className ? ' ' + className : '')}
            title={title}
            onClick={onClick}
            disabled={disabled}
        >
            {children}
        </button>
    );
};

export default React.memo(IconButton);
